var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1746_28322)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.22358 3.20187C6.49632 3.15867 6.6824 2.90255 6.6392 2.62981C6.596 2.35707 6.33988 2.17099 6.06714 2.21418C4.42689 2.47397 3.14046 3.7604 2.88067 5.40066C2.83747 5.6734 3.02355 5.92952 3.29629 5.97272C3.56904 6.01592 3.82516 5.82983 3.86836 5.55709C4.06038 4.34473 5.01121 3.39389 6.22358 3.20187Z",
    fill: "#ACB9C7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3335 0.166992C3.74365 0.166992 0.833496 3.07714 0.833496 6.66699C0.833496 10.2568 3.74365 13.167 7.3335 13.167C10.9233 13.167 13.8335 10.2568 13.8335 6.66699C13.8335 3.07714 10.9233 0.166992 7.3335 0.166992ZM1.8335 6.66699C1.8335 3.62943 4.29593 1.16699 7.3335 1.16699C10.3711 1.16699 12.8335 3.62943 12.8335 6.66699C12.8335 9.70456 10.3711 12.167 7.3335 12.167C4.29593 12.167 1.8335 9.70456 1.8335 6.66699Z",
    fill: "#ACB9C7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0204 11.6468C12.8252 11.4516 12.5086 11.4516 12.3133 11.6468C12.1181 11.8421 12.1181 12.1587 12.3133 12.3539L14.9799 15.0206C15.1752 15.2158 15.4918 15.2158 15.687 15.0206C15.8823 14.8253 15.8823 14.5087 15.687 14.3135L13.0204 11.6468Z",
    fill: "#ACB9C7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1746_28322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.9cfbc3f2badd584e2a8e65deaaec4d79.svg";
export { ForwardRef as ReactComponent };